module.exports = __webpack_public_path__ + "static/media/picture-(178).09ada55a.JPG";